import { Typography } from '@mui/material';

export default function SectionTitle({ title }: { title: string }) {
  return <Typography fontWeight={600}>{title}</Typography>;
}
